import React, { forwardRef, InputHTMLAttributes } from 'react'
import { clsx } from 'clsx'

import { Field, FieldBaseProps } from '../_internal/Field/Field'
import { Box, BoxProps } from '../Box/Box'
import { TextProps } from '../Text/Text'

import * as styles from './TextField.css'

type NativeInputProps = React.AllHTMLAttributes<HTMLInputElement>

type InputCallbackProps = {
    onBlur?: NativeInputProps['onBlur']
    onChange?: React.EventHandler<React.ChangeEvent<HTMLInputElement>>
    onFocus?: NativeInputProps['onFocus']
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
}

type Props = {
    placeholder?: string
    type?: NativeInputProps['type']
    fontSize?: TextProps['fontSize']
    fontWeight?: TextProps['fontWeight']
    textAlign?: TextProps['textAlign']
    paddingX?: BoxProps['paddingX']
    inputWidth?: BoxProps['width']
    inputLimit?: number
    color?: TextProps['color']
} & FieldBaseProps &
    InputCallbackProps &
    Omit<InputHTMLAttributes<HTMLInputElement>, 'height'>

export const TextField = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const {
        type,
        placeholder,
        fontSize,
        fontWeight,
        autoComplete,
        inputWidth,
        inputLimit,
        color,
        ...fieldProps
    } = props
    return (
        <Field {...fieldProps}>
            {(overlays, { className, ...inputProps }) => (
                <>
                    <Box
                        ref={ref}
                        as="input"
                        {...inputProps}
                        type={type}
                        placeholder={placeholder}
                        className={clsx(className, styles.input)}
                        fontSize={fontSize}
                        fontWeight={fontWeight}
                        autoComplete={autoComplete || 'off'}
                        width={inputWidth}
                        maxLength={inputLimit}
                        color={color}
                    />
                    {overlays}
                </>
            )}
        </Field>
    )
})
